import moment from 'moment';

export default function() {
  'ngInject';

  function extensionDateCheck(extension_date, cycle_date) {
    const a = moment(cycle_date);
    const b = moment(extension_date);

    return a.isValid() && b.isValid() && b.isSameOrAfter(a) && b.diff(a, 'years', true) < 1;
  }

  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, element, attr, ngModel) {
      ngModel.$validators.dateRangeValidation = function(modelValue, viewValue) {
        const extension_date = modelValue || viewValue;

        return extensionDateCheck(extension_date, attr.cycleDate);
      };
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/dateRangeValidation/index.js